var React = require('react');

function ArrowRight2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow","transform":"translate(19474.771 8978.768)"},React.createElement("g",{"id":"Group_755","data-name":"Group 755","transform":"translate(-19474.771 -8978)"},[React.createElement("path",{"id":"Path_865","data-name":"Path 865","d":"M17,4,29,14,17,24","transform":"translate(7 -4)","fill":"none","stroke":"#e43d30","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_233","data-name":"Line 233","x2":"35.503","transform":"translate(0 10)","fill":"#fff","stroke":"#e43d30","strokeMiterlimit":"10","strokeWidth":"2","key":1})])));
}

ArrowRight2.defaultProps = {"width":"37.562","height":"21.536","viewBox":"0 0 37.562 21.536"};

module.exports = ArrowRight2;

ArrowRight2.default = ArrowRight2;
